import { Pipe, PipeTransform } from '@angular/core';
import { formatCnpj } from '../../utils';

@Pipe({
  name: '_cnpj',
  pure: true,
  standalone: false,
})
export class CnpjPipe implements PipeTransform {
  public transform(value: string): any {
    if (!value) {
      return;
    }
    return formatCnpj(value);
  }
}
